import { getConsultantOptionsFromAPI } from "@/common/services/employee.api";
import { useState, useEffect } from "react";

interface SelectOption {
  label: string;
  value: string;
}

export function useConsultants(): {
  options: SelectOption[];
  isLoading: boolean;
  error: string | null;
} {
  const [options, setOptions] = useState<SelectOption[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchConsultants() {
      setIsLoading(true);
      setError(null);
      try {
        const result = await getConsultantOptionsFromAPI();
        setOptions(result);
      } catch (err) {
        console.error("Erro ao carregar consultores:", err);
        setError("Falha ao carregar a lista de consultores.");
        setOptions([{ value: "", label: "Erro ao carregar" }]);
      } finally {
        setIsLoading(false);
      }
    }
    fetchConsultants();
  }, []);

  return { options, isLoading, error };
}
